import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from "react-redux";

import adminAuthReducer from "./slices/adminAuthSlice";
import adminStatsReducer from "./slices/adminStatsSlice";
import adminTextsReducer from "./slices/adminTextsSlice";
import adminUsersReducer from "./slices/adminUsersSlice";
import adminVoicesReducer from "./slices/adminVoicesSlice";
import contactSettingsReducer from "./slices/contactSettingsSlice";
import diagnosticsReducer from "./slices/diagnosticsSlice";
import productAnalyticsReducer from "./slices/productAnalyticsSlice";
import registrationSettingsReducer from "./slices/registrationSettingsSlice";
import textQualityReducer from "./slices/textQualitySlice";
import userActivityReducer from "./slices/userActivitySlice";

export const store = configureStore({
  reducer: {
    adminAuth: adminAuthReducer,
    contactSettings: contactSettingsReducer,
    registrationSettings: registrationSettingsReducer,
    diagnostics: diagnosticsReducer,
    adminVoices: adminVoicesReducer,
    adminUsers: adminUsersReducer,
    adminTexts: adminTextsReducer,
    adminStats: adminStatsReducer,
    productAnalytics: productAnalyticsReducer,
    userActivity: userActivityReducer,
    textQuality: textQualityReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  devTools: import.meta.env.MODE !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
